var MapMarker = /** @class */ (function () {
    function MapMarker(category, icon, location) {
        this.category = category;
        this.icon = icon.fixIconUrl();
        this.location = location;
        this.marker = this.createMarkerInternal();
    }
    MapMarker.prototype.hasPopup = function () {
        var _a, _b;
        return this.location.title.length > 0 || ((_b = (_a = this.location.teaser) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) > 0 || this.location.links.length > 0;
    };
    MapMarker.prototype.generatePopupContent = function () {
        var _a, _b;
        if (!this.hasPopup())
            return '';
        var content = '';
        if (this.location.title.length > 0) {
            content += "<p class=\"marker-title\">".concat(this.location.title, "</p>");
        }
        if (((_b = (_a = this.location.teaser) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            content += "<p class=\"marker-teaser\">".concat(this.location.teaser, "</p>");
        }
        if (this.location.links.length > 0) {
            content += '<ul class="marker-links">';
            this.location.links.forEach(function (link) {
                content += "<li class=\"marker-link\"><a href=\"".concat(link.link, "\" target=\"_blank\">").concat(link.description, "</a></li>");
            });
            content += '</ul>';
        }
        return content;
    };
    return MapMarker;
}());
export default MapMarker;
